import {
  type EntityV2Req,
  EntityV2Type,
  TempEntityV2Type,
} from '@revelio/data-access';

import {
  type Filter,
  FilterId,
  FilterType,
  type TreeFilter,
} from '../types/filters';

export const getCompanySummaryFilters = (
  filters: Filter[]
): EntityV2Req | null => {
  const selectedPrimaryFilter = (
    filters.find((filter) => filter.id === FilterId.COMPANY) as TreeFilter
  )?.primarySelections?.find((selection) => selection.isActive);
  const selectedCompanyRCID =
    selectedPrimaryFilter?.id?.split('_').pop() || selectedPrimaryFilter?.id;

  if (!selectedCompanyRCID) return null;

  return {
    entID: Number(selectedCompanyRCID),
    entType: EntityV2Type.Company,
    numCompetitors: 7,
  };
};

export const getRoleSummaryFilters = (
  filters: Filter[]
): EntityV2Req | null => {
  const primaryFilter = filters.find((filter) => filter.id === FilterId.ROLE);

  if (primaryFilter?.type !== FilterType.TREE) return null;

  const selectedPrimaryFilter = primaryFilter?.primarySelections?.find(
    (selection) => selection.isActive
  );

  if (!selectedPrimaryFilter) return null;

  const entType = (() => {
    switch (selectedPrimaryFilter.levelId) {
      case 'role_k7':
        return EntityV2Type.RoleK7;
      case 'role_k150':
        return EntityV2Type.RoleK150;
      case 'role_k1500':
        return EntityV2Type.RoleK1500;

      // TODO: Replace with EntityV2Type when available
      case 'role_k15000':
        return TempEntityV2Type.RoleK15000 as unknown as EntityV2Type;
      default:
        return null;
    }
  })();

  if (!entType) return null;

  return {
    entID: Number(
      selectedPrimaryFilter.id.split('_').pop() || selectedPrimaryFilter.id
    ),
    entType,
  };
};
